import DeviceFragment from 'components/core/DeviceFragment';
import { HStack, VStack } from 'reaction';
import CTAButtonGroup from './CTAButtonGroup';
import './FlexBrowser.css';

export default function FlexBrowser() {
    return (
        <>
            <DeviceFragment type={['largeDesktop', null]}>
                <VStack className='flex-browser-section large-desktop'>
                    <HStack justify='between'>
                        <img
                            src='https://github.com/VirajShah21/FlexBrowser/blob/main/icon.png?raw=true'
                            alt='Flex Browser Icon'
                        />
                        <VStack align='start' className='flex-browser-details'>
                            <h2>Flex Browser</h2>
                            <p>
                                One day I was using a web browser. Then I wanted to create my own.
                                And so I did. Flex Browser is a lightning fast browser with very
                                little overhead.
                            </p>
                            <p>
                                Flex Browser comes packed with all the basic features you would
                                expect in any web browser. Multiple browser windows, bookmark
                                manager, history, password manager. Additionally, everything is
                                customizable; from the colors straight down to the icons and
                                buttons.
                            </p>
                            <p>The best part: The app icon is an illustration of my dog, Draco.</p>
                            <CTAButtonGroup />
                        </VStack>
                    </HStack>
                </VStack>
            </DeviceFragment>

            <DeviceFragment type={[null, 'desktop']}>
                <VStack className='flex-browser-section desktop'>
                    <img
                        src='https://github.com/VirajShah21/FlexBrowser/blob/main/icon.png?raw=true'
                        alt='Flex Browser Icon'
                    />
                    <VStack align='start' className='flex-browser-details'>
                        <h2>Flex Browser</h2>
                        <p>
                            One day I was using a web browser. Then I wanted to create my own. And
                            so I did. Flex Browser is a lightning fast browser with very little
                            overhead.
                        </p>
                        <p>
                            Flex Browser comes packed with all the basic features you would expect
                            in any web browser. Multiple browser windows, bookmark manager, history,
                            password manager. Additionally, everything is customizable; from the
                            colors straight down to the icons and buttons.
                        </p>
                        <p>The best part: The app icon is an illustration of my dog, Draco.</p>
                        <CTAButtonGroup />
                    </VStack>
                </VStack>
            </DeviceFragment>
        </>
    );
}
